export const environment = {
  prodiction: false,
};
export const baseUrl = 'https://loyalty.autoidea.pl/api/';
// export const baseUrl = 'https://saapi-app.smarterpod.eu/';
